export enum ErrorModulesEnum {
  CHARACTER_GENERATION = 'character_generation',
  IMAGE_GENERATION = 'image_generation'
}

export interface ErrModel {
  message?: string;
  type?: string;
  status?: string;
}